export default class LocalStorage {
    removeItem(key) {
        localStorage.removeItem(key);
        return Promise.resolve();
    }
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    getItem(key) {
        const item = localStorage.getItem(key);
        if (item) {
            try {
                return Promise.resolve(JSON.parse(item));
            }
            catch {
                console.error('Found invalid json data in local storage, ignoring');
            }
        }
        return Promise.resolve(undefined);
    }
    hasItem(key) {
        return Promise.resolve(localStorage.getItem(key) !== null);
    }
    clear() {
        localStorage.clear();
        return Promise.resolve();
    }
}
//# sourceMappingURL=LocalStorage.js.map